import { fireEvent } from 'utils/generic/event-bus';

export enum EFreeBetsActions {
  GET_FREE_BETS = 'GET_FREE_BETS'
}

export const fireGetFeeBets = () => {
  fireEvent({
    key: EFreeBetsActions.GET_FREE_BETS
  });
};
